const session_expired = {
    title: 'انتهت صلاحية الجلسة',
    subtitle: 'قد تكون جلستك قد انتهت وتم قطع الاتصال. انقر على الزر أدناه لتسجيل الدخول إلى واجهة التحكم الإدارية مرة أخرى.',
    button: 'تسجيل الدخول مرة أخرى',
};
export default Object.freeze(session_expired);
